import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { hideDialog } from '../actions/index';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

import EditCvTipoZona from '../components/dialogs/mae_auxiliares_tipo_zona/edit_cv_tipo_zona';
import EditCvGrupoPartida from '../components/dialogs/mae_auxiliares_grupo_partida/edit_cv_grupo_partida';
import EditCvTipoZonaIva from '../components/dialogs/mae_auxiliares_tipo_zona_iva/edit_cv_tipo_zona_iva';
import EditCvTipoPartida from '../components/dialogs/mae_auxiliares_tipo_partida/edit_cv_tipo_partida';
import EditCvTipoArticulo from '../components/dialogs/mae_auxiliares_tipo_articulos/edit_cv_tipo_articulos';
import EditCvTipoGasto from '../components/dialogs/mae_auxiliares_tipo_gasto/edit_cv_tipo_gasto';
import EditCvTipoMaquina from '../components/dialogs/mae_auxiliares_tipo_maquina/edit_cv_tipo_maquina';
import EditVModeloMaquina from '../components/dialogs/mae_auxiliares_modelo_maquina/edit_v_modelo_maquina';
import EditCentroUsuario from '../components/dialogs/mae_auxiliares_perfiles_usuario/edit_centro_usuario';
import EditCajaCentro from '../components/dialogs/mae_centro/edit_caja_centro';
import EditZonaIvaCentro from '../components/dialogs/mae_centro/edit_zonaiva_centro';
import EditContabCentro from '../components/dialogs/mae_centro/edit_contab_centro';
import EditZonaCentro from '../components/dialogs/mae_centro/edit_zona_centro';
import EditCentroCentro from '../components/dialogs/mae_centro/edit_centro_centro';
import EditFondo from '../components/dialogs/mae_centro/edit_fondo';


import EditContadorMaquina from '../components/dialogs/mae_maquina/edit_maquina_contador';
import EditIncidenciaMaquina from '../components/dialogs/mae_maquina/edit_maquina_incidencia';
import EditLicenciaMaquina from '../components/dialogs/mae_maquina/edit_maquina_licencia';
import EditItvMaquina from '../components/dialogs/mae_maquina/edit_maquina_itv';
import EditCentroMaquina from '../components/dialogs/mae_maquina/edit_maquina_centro';

import EditZonaTipoPartida from '../components/dialogs/mae_zona/edit_zona_tipopartida';
import EditZonaProduct from '../components/dialogs/mae_zona/edit_zona_productos';
import EditZonaProductCaja from '../components/dialogs/mae_zona/edit_zona_productos_caja';
import CentroNew from '../containers/dialogs/centro_new';
import MoreDetailsCentro from '../components/dialogs/mae_centro/more_details_centro';
import SimpleMessage from '../components/dialogs/simple_message';
import ConfirmationDialog from '../components/dialogs/confirmation_dialog';
import CierreDiarioMKTGrid from '../containers/acc_cierre_diario/cierre_diario_mkt_grid';
import EditMktGrid from '../components/dialogs/cierre_diario_mkt_grid_edit';
import CierreDiarioArcadeGrid from '../containers/acc_cierre_diario/cierre_diario_arcade_grid';
import EditArcadeGrid from '../components/dialogs/cierre_diario_arcade_grid_edit';
import CierreDiarioGastosGrid from '../containers/acc_cierre_diario/cierre_diario_gastos_grid';
import EditGastosGrid from '../components/dialogs/cierre_diario_gastos_grid_edit';
import CierreDiarioPorHoras from '../containers/acc_cierre_diario/cierre_diario_por_horas';
import CierreDiarioPartidasTipoGrid from '../containers/acc_cierre_diario/cierre_diario_partidas_tipo_grid';
import EditPartidasPorTipoGrid from '../components/dialogs/cierre_diario_partidas_tipo_grid_edit';
import CierreDiarioObservaciones from '../components/dialogs/cierre_diario_observaciones';
import Arqueo from '../containers/arqueo';
import CierreSemanalLecturasArcade from '../containers/acc_cierre_semanal/cierre_semanal_lect_arcade';
import CierreSemanalLecturasArcadeDetail from '../containers/acc_cierre_semanal/cierre_semanal_lect_arcade_detail';
import EditLectArcade from '../components/dialogs/cierre_semanal_lect_arcade_edit';
import CierreSemanalResumenGastos from '../containers/acc_cierre_semanal/cierre_semanal_resumen_gastos';
import CierreSemanalResumenVisas from '../containers/acc_cierre_semanal/cierre_semanal_resumen_visas';
import CierreSemanalResumenMKT from '../containers/acc_cierre_semanal/cierre_semanal_resumen_mkt';
import CierreSemanalResumenBanco from '../containers/acc_cierre_semanal/cierre_semanal_resumen_banco';
import CalendarioSemanal from '../components/dialogs/cierre_semanal_calendario';


import MaeAuxiliaresTipoZona from '../containers/mae_auxiliares_tipo_zona/mae_auxiliares_tipo_zona';

import IncrPresupuestos from '../components/dialogs/presupuestos_incr';
import PresupuestoDetalle from '../containers/ent_presupuestos/presupuesto_detalle';

import SelectMaquina from '../components/dialogs/select_maquina';
import EditIncidencia from '../components/dialogs/ent_alertas_edit_inicidencia';

import EditLecturasContador from '../containers/mae_maquina/edit_lecturas_contador';
import ListaMovimientos from '../containers/mae_centro/lista_movimientos';

import CentroMailing from '../containers/mae_centro/centro_mailing';

import PdfViewer from '../components/dialogs/pdf_viewer';
import ReportGeneric from './report_generic';
import ReportRankingMaquinas from './report_ranking_maquinas';
import ReportRegalosEntregados from './report_regalos_entregados';

import TextBoxDialog from '../components/dialogs/textbox_dialog';

import EditCvFamilia from '../components/dialogs/mae_redemption_familia/edit_familia';
import EditCvSubFamilia from '../components/dialogs/mae_redemption_sub_familia/edit_sub_familia';
import EditTipoFicha from '../components/dialogs/mae_redemption_tipo_ficha/edit_tipo_ficha';
import EditTipoFichaSub from '../components/dialogs/mae_redemption_tipo_ficha_sub/edit_tipo_ficha_sub';
import EditTipoMovRedem from '../components/dialogs/mae_redemption_tipo_mov_redem/edit_tipo_mov_redem';
import EditPromocion from '../components/dialogs/mae_redemption_promocion/edit_promocion';
import EditNuevoAlbaran from '../components/dialogs/ent_albaran_pdte/edit_nuevo_albaran';
import EditListaAlbaran from '../components/dialogs/ent_pedido/edit_lista_albaran';
import EditInventario from '../components/dialogs/acc_inventario/edit_inventario';
import EditCvMotivo from '../components/dialogs/mae_redemption_motivo/edit_motivo';
import EditCodigoBarras from '../components/dialogs/mae_redemption_articulo/edit_codigo_barras';
import ListArticulos from '../components/dialogs/mae_redemption_articulo/list_articulos_dialog';
import EditSegmentacion from '../components/dialogs/mae_redemption_segmentacion/edit_segmentacion';

import ChangePasswordDialog from '../containers/change_password_dialog';

import ReportDataGrid from '../containers/report_datagrid';

const styles = theme => ({

    paper: {
        position: 'absolute',
        width: theme.spacing(1) * 50,
        height: '500px',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(1) * 4,
    }

});


const MODAL_COMPONENTS = {
    'EditCvGrupoPartida': EditCvGrupoPartida,
    'EditCvTipoPartida': EditCvTipoPartida,
    'EditCvTipoArticulo': EditCvTipoArticulo,
    'EditCvTipoGasto': EditCvTipoGasto,
    'EditCvTipoMaquina': EditCvTipoMaquina,
    'EditVModeloMaquina': EditVModeloMaquina,
    'EditCvTipoZona': EditCvTipoZona,
    'EditCajaCentro': EditCajaCentro,
    'EditZonaIvaCentro': EditZonaIvaCentro,
    'EditZonaCentro': EditZonaCentro,
    'EditContabCentro': EditContabCentro,
    'CentroNew': CentroNew,
    'MoreDetailsCentro': MoreDetailsCentro,
    'EditCentroCentro': EditCentroCentro,
    'EditCentroUsuario': EditCentroUsuario,
    'EditCvTipoZonaIva': EditCvTipoZonaIva,
    'EditFondo': EditFondo,

    //cierre diario
    'CierreDiarioMKTGrid': CierreDiarioMKTGrid,
    'EditMktGrid': EditMktGrid,
    'CierreDiarioArcadeGrid': CierreDiarioArcadeGrid,
    'MaeAuxiliaresTipoZona': MaeAuxiliaresTipoZona,
    'EditArcadeGrid': EditArcadeGrid,
    'CierreDiarioGastosGrid': CierreDiarioGastosGrid,
    'EditGastosGrid': EditGastosGrid,
    'CierreDiarioPartidasTipoGrid': CierreDiarioPartidasTipoGrid,
    'EditPartidasPorTipoGrid': EditPartidasPorTipoGrid,
    'CierreDiarioPorHoras': CierreDiarioPorHoras,
    'Arqueo': Arqueo,
    'CierreDiarioObservaciones': CierreDiarioObservaciones,

    'EditZonaTipoPartida': EditZonaTipoPartida,
    'EditZonaProduct': EditZonaProduct,
    'EditZonaProductCaja': EditZonaProductCaja,
    'EditContadorMaquina': EditContadorMaquina,
    'EditIncidenciaMaquina': EditIncidenciaMaquina,
    'EditLicenciaMaquina': EditLicenciaMaquina,
    'EditItvMaquina': EditItvMaquina,
    'EditCentroMaquina': EditCentroMaquina,
    'SimpleMessage': SimpleMessage,
    'ConfirmationDialog': ConfirmationDialog,

    //cierre semanal
    'CierreSemanalLecturasArcade': CierreSemanalLecturasArcade,
    'CierreSemanalLecturasArcadeDetail': CierreSemanalLecturasArcadeDetail,
    'EditLectArcade': EditLectArcade,
    'CierreSemanalResumenVisas': CierreSemanalResumenVisas,
    'CierreSemanalResumenGastos': CierreSemanalResumenGastos,
    'CierreSemanalResumenMKT': CierreSemanalResumenMKT,
    'CierreSemanalResumenBanco': CierreSemanalResumenBanco,
    'CalendarioSemanal': CalendarioSemanal,

    //presupuestos
    'IncrPresupuestos': IncrPresupuestos,
    'PresupuestoDetalle': PresupuestoDetalle,

    'SelectMaquina': SelectMaquina,
    'EditIncidencia': EditIncidencia,

    'EditLecturasContador': EditLecturasContador,
    'ListaMovimientos': ListaMovimientos,

    'CentroMailing': CentroMailing,

    'PdfViewer': PdfViewer,
    'ReportGeneric': ReportGeneric,
    'ReportRankingMaquinas': ReportRankingMaquinas,
    'ReportRegalosEntregados':ReportRegalosEntregados,
    'TextBoxDialog': TextBoxDialog,

    // maestros redemption
    'EditCvFamilia': EditCvFamilia,
    'EditCvSubFamilia': EditCvSubFamilia,
    'EditTipoFicha': EditTipoFicha,
    'EditTipoFichaSub': EditTipoFichaSub,
    'EditTipoMovRedem': EditTipoMovRedem,
    'EditPromocion': EditPromocion,
    'EditCvMotivo': EditCvMotivo,
    'ListArticulos': ListArticulos,
    'EditSegmentacion': EditSegmentacion,

    // redemption
    'EditListaAlbaran': EditListaAlbaran,
    'EditNuevoAlbaran': EditNuevoAlbaran,
    'EditInventario': EditInventario,
    'EditCodigoBarras' : EditCodigoBarras,

    'ReportDataGrid': ReportDataGrid,

    'ChangePasswordDialog': ChangePasswordDialog,

};

class DialogsRoot extends Component {

    render() {
        return (
            <div>
                {this.props.dialogs.map((dialog, index) => {
                    let top = index * 5;
                    let left = index * 5;
                    const SpecificModal = MODAL_COMPONENTS[dialog.modalType];
                    return (
                        <Dialog key={dialog.dialogid} onClose={this.props.hideDialog} aria-labelledby="simple-dialog-title" open={dialog.modalOpen}
                            style={{ top: `${top}%`, left: `${left}%` }} disableBackdropClick={dialog.disableBackdrop} fullWidth maxWidth={dialog.maxWidth} disableEscapeKeyDown={true} >
                            <DialogContent>
                                <SpecificModal {...dialog.modalProps} isDialog hideDialog={this.props.hideDialog} />
                            </DialogContent>
                        </Dialog>
                    );
                })}
            </div>
        );
    };

};

DialogsRoot.propTypes = {
    //state:
    dialogs: PropTypes.array.isRequired,
    //dispatch:
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        dialogs: state.dialogs
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ hideDialog: hideDialog }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(DialogsRoot))